export class DeleteUserRights {
  public mailDestinataireId?: number;
  public delete?: boolean;
  public replyToAction?: boolean;

  constructor(data: Partial<DeleteUserRights>) {
    Object.assign(this, data);
  }
}
